import React, { Component } from 'react';
import { observer } from 'mobx-react';
import dshStore from '../request/model';
import { getProject } from '../request/dao';
import './index.styl';
import pictureArr from './picture/index';
import Zmage from 'react-zmage';

const clzpre = 'dsh-project';

@observer
class Project extends Component {
    constructor(props) {
        super(props);
        this.pictureArr = [
            {
                url: pictureArr[0],
                type: 'picture'
            },
            {
                url: pictureArr[1],
                type: 'picture'
            },
            {
                url: pictureArr[2],
                type: 'picture'
            },
            {
                url: pictureArr[3],
                type: 'picture'
            },
            {
                url: pictureArr[4],
                type: 'picture'
            }
        ];
        getProject();
    }

    generatePictureArea = arr => {
        return (arr || []).map((item, index) => {
            const url = item.url || [];
            if (url[0]) {
                return (
                    <Zmage
                        edge={100}
                        backdrop="#080935"
                        key={url[0]}
                        src={url[0]}
                        className={'single-picture'}
                        alt="地址无效"
                    />
                );
            } else {
                return '';
            }
        });
    };

    render() {
        const { projects } = this.props.dshStore;
        return (
            <div className={`${clzpre} dsh-box`}>
                <h3>项目风采</h3>
                <div className={'picture-area'}>
                    <div className={'picture-row'}>{this.generatePictureArea((projects || []).slice(0, 2))}</div>
                    <div className={'picture-row'}>{this.generatePictureArea((projects || []).slice(2))}</div>
                </div>
            </div>
        );
    }
}

export default props => <Project {...props} dshStore={dshStore} />;
